import { ConnectionPositionPair } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import moment from 'moment-timezone';

import { I18nService } from '@recruitee/i18n';
import { timeValidator } from '@recruitee/time';
import { RtStatefulComponent } from '@recruitee/user-interface';

type State = {
  dropdownOpen: boolean;
};

@Component({
  selector: 'rt-schedule-time-picker',
  templateUrl: 'schedule-time-picker.component.html',
  styleUrls: ['./schedule-time-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleTimePickerComponent extends RtStatefulComponent<State> {
  @Input() public time: string;
  @Input() public dropdownMaxHeight: number = 300;
  @Input() public dark: boolean = true;
  @Input() public timeInterval: number = 15;
  @Input()
  public placeholder: string = this.i18n.translate(
    'app.interview.schedule_dialog.time_placeholder',
  );
  @Input() public fullWidth: boolean = false;
  @Input() public invalid: boolean = false;

  @Output() public timeChange: EventEmitter<string> = new EventEmitter();

  public readonly dropdownPositions: ConnectionPositionPair[] = [
    new ConnectionPositionPair(
      { originX: 'start', originY: 'bottom' },
      { overlayX: 'start', overlayY: 'top' },
    ),
  ];
  public readonly dropdownWidth: number = 120;
  public timeControl: UntypedFormControl;

  constructor(
    protected cdRef: ChangeDetectorRef,
    private i18n: I18nService,
  ) {
    super(cdRef);
    this.createState({
      dropdownOpen: false,
    });
  }

  public ngOnInit(): void {
    this.timeControl = new UntypedFormControl(
      moment(this.time, 'HH:mm').format('LT'),
      timeValidator,
    );
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { time } = changes;

    if (time?.currentValue && this.timeControl) {
      this.timeControl.setValue(moment(time.currentValue, 'HH:mm').format('LT'));
    }
  }

  public toggleDropdown(state: boolean | undefined = undefined): void {
    this.setState({
      dropdownOpen: state === undefined ? !this.state.dropdownOpen : state,
    });
  }

  public onTimeChange(time: string): void {
    this.toggleDropdown(false);
    if (moment(time, 'LT').isValid()) {
      this.timeChange.emit(moment(time, 'LT').format('HH:mm'));
    }
  }
}
